import { render, staticRenderFns } from "./pedidosDetails.vue?vue&type=template&id=1960c8aa&"
import script from "./pedidosDetails.vue?vue&type=script&lang=js&"
export * from "./pedidosDetails.vue?vue&type=script&lang=js&"
import style0 from "./pedidosDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports